module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stream-browserify/~/readable-stream/duplex-browser.js
// module id = 425
// module chunks = 2